// extracted by css-extract-rspack-plugin
export default {"root":"root-3Gz4a","wrapper":"wrapper-z6MNl","icon":"icon-3gIGC","content":"content-135QZ","copy":"copy-1wBBW"};